import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoanWorkflowManager from '../components/workflow/LoanWorkflowManager';

const WorkflowPage: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateForm = () => {
    navigate('/forms/builder');
  };

  const handleCreateRule = () => {
    navigate('/rules/builder');
  };

  const handleCreateWorkflow = () => {
    navigate('/workflows/builder/new');
  };

  const handleEditForm = (formId: string) => {
    navigate(`/forms/builder/${formId}`);
  };

  const handleEditRule = (ruleId: string) => {
    navigate(`/rules/builder/${ruleId}`);
  };

  return (
    <LoanWorkflowManager
      onCreateForm={handleCreateForm}
      onCreateRule={handleCreateRule}
      onCreateWorkflow={handleCreateWorkflow}
      onEditForm={handleEditForm}
      onEditRule={handleEditRule}
    />
  );
};

export default WorkflowPage;
